/* eslint-disable import/prefer-default-export */
// Earliest date for which performance data is available. Kept as an ISO date
// string so each consumer can parse it with its own date library.
export const MIN_DATE = '2026-01-01';
